import { gql } from '@apollo/client';
import { PROGRAMME } from '../fragments';

export const ALL_SERVICE_PROVIDER_PROGRAMMES = gql`
  query AllServiceProviderProgrammes($input: FilterArgs) {
    programmes: serviceProviderProgrammes(input: $input) {
      ...programme
      geographies {
        id
        name
      }
      reportersCount
      theoryOfChangeFile {
        id
        name
        url
      }
    }
  }
  ${PROGRAMME}
`;
